import { docReady } from "./utils";
import navbarInit from "./navbar-darken-on-scroll";
import detectorInit from "./detector";
import zanimationInit from "./zanimation";

/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(navbarInit);
docReady(detectorInit);
docReady(zanimationInit);

